<template>
  <div class="chessboard-wrapper">
    <div class="chessboard-container">
      <!-- Plateau SVG -->

      <!-- <img :src="boardImage" class="board-image" alt="Chess Board" /> -->
<svg class="board-image" viewBox="0 0 320 320" xmlns="http://www.w3.org/2000/svg">
  <!-- Cases -->
  <!-- Ligne 8 -->
  <rect x="0" y="0" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="40" y="0" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="80" y="0" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="120" y="0" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="160" y="0" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="200" y="0" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="240" y="0" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="280" y="0" width="40" height="40" fill="var(--svg-board-bc)" />
  <!-- Ligne 7 -->
  <rect x="0" y="40" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="40" y="40" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="80" y="40" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="120" y="40" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="160" y="40" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="200" y="40" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="240" y="40" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="280" y="40" width="40" height="40" fill="var(--svg-board-bg)" />
  <!-- Ligne 6 -->
  <rect x="0" y="80" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="40" y="80" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="80" y="80" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="120" y="80" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="160" y="80" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="200" y="80" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="240" y="80" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="280" y="80" width="40" height="40" fill="var(--svg-board-bc)" />
  <!-- Ligne 5 -->
  <rect x="0" y="120" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="40" y="120" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="80" y="120" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="120" y="120" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="160" y="120" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="200" y="120" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="240" y="120" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="280" y="120" width="40" height="40" fill="var(--svg-board-bg)" />
  <!-- Ligne 4 -->
  <rect x="0" y="160" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="40" y="160" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="80" y="160" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="120" y="160" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="160" y="160" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="200" y="160" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="240" y="160" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="280" y="160" width="40" height="40" fill="var(--svg-board-bc)" />
  <!-- Ligne 3 -->
  <rect x="0" y="200" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="40" y="200" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="80" y="200" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="120" y="200" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="160" y="200" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="200" y="200" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="240" y="200" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="280" y="200" width="40" height="40" fill="var(--svg-board-bg)" />
  <!-- Ligne 2 -->
  <rect x="0" y="240" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="40" y="240" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="80" y="240" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="120" y="240" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="160" y="240" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="200" y="240" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="240" y="240" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="280" y="240" width="40" height="40" fill="var(--svg-board-bc)" />
  <!-- Ligne 1 -->
  <rect x="0" y="280" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="40" y="280" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="80" y="280" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="120" y="280" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="160" y="280" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="200" y="280" width="40" height="40" fill="var(--svg-board-bg)" />
  <rect x="240" y="280" width="40" height="40" fill="var(--svg-board-bc)" />
  <rect x="280" y="280" width="40" height="40" fill="var(--svg-board-bg)" />

  <!-- Bordure -->
  <rect x="0" y="0" width="320" height="320" fill="none" stroke="var(--svg-board-coord)" stroke-width="3"/>
</svg>



      <!-- Overlay coordonnées -->
      <svg viewBox="0 0 100 100" class="coordinates" aria-hidden="true">
        <text x="0.75" y="3.5" font-size="2.8" class="coordinate-light">8</text>
        <text x="0.75" y="15.75" font-size="2.8" class="coordinate-dark">7</text>
        <text x="0.75" y="28.25" font-size="2.8" class="coordinate-light">6</text>
        <text x="0.75" y="40.75" font-size="2.8" class="coordinate-dark">5</text>
        <text x="0.75" y="53.25" font-size="2.8" class="coordinate-light">4</text>
        <text x="0.75" y="65.75" font-size="2.8" class="coordinate-dark">3</text>
        <text x="0.75" y="78.25" font-size="2.8" class="coordinate-light">2</text>
        <text x="0.75" y="90.75" font-size="2.8" class="coordinate-dark">1</text>
        <text x="10" y="99" font-size="2.8" class="coordinate-dark">A</text>
        <text x="22.5" y="99" font-size="2.8" class="coordinate-light">B</text>
        <text x="35" y="99" font-size="2.8" class="coordinate-dark">C</text>
        <text x="47.5" y="99" font-size="2.8" class="coordinate-light">D</text>
        <text x="60" y="99" font-size="2.8" class="coordinate-dark">E</text>
        <text x="72.5" y="99" font-size="2.8" class="coordinate-light">F</text>
        <text x="85" y="99" font-size="2.8" class="coordinate-dark">G</text>
        <text x="97.5" y="99" font-size="2.8" class="coordinate-light">H</text>
      </svg>
      
      <!-- Grille interactive -->
      <div class="chess-board" v-if="pieces.length === 8">
        <div v-for="rowIndex in 8" :key="rowIndex" class="row">
          <div
            v-for="colIndex in 8"
            :key="colIndex"
            class="square"
            :class="[
              getSquareClass(rowIndex - 1, colIndex - 1),
              { 
                'selected': selectedPiece && selectedPiece.row === rowIndex - 1 && selectedPiece.col === colIndex - 1,
                'capture': isCaptureMove(rowIndex - 1, colIndex - 1),
                'disabled': isAIThinking || currentTurn === 'black'
              }
            ]"
            @click="handleSquareClick(rowIndex - 1, colIndex - 1)"
          >
            <!-- Indicateur de mouvement possible -->
            <div 
              v-if="isPossibleMove(rowIndex - 1, colIndex - 1) && !isCaptureMove(rowIndex - 1, colIndex - 1)" 
              class="possible-move"
            ></div>
            <!-- Indicateur de capture -->
            <div 
              v-if="isCaptureMove(rowIndex - 1, colIndex - 1)" 
              class="capture-indicator"
            ></div>
            <!-- Pièce -->
            <img
              v-if="pieces[rowIndex - 1] && pieces[rowIndex - 1][colIndex - 1]"
              :src="getPieceImage(pieces[rowIndex - 1][colIndex - 1])"
              class="piece"
              :class="pieces[rowIndex - 1][colIndex - 1].color"
              draggable="false"
            />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Status et indicateur IA -->
    <div class="game-info">
      <div v-if="isAIThinking" class="ai-thinking">
        <div class="spinner"></div>
        L'IA réfléchit...
      </div>
      <div v-if="showStatus && status" class="status">{{ status }}</div>
      <div class="turn-indicator">
        Tour : {{ currentTurn === 'white' ? 'Joueur (Blanc)' : 'IA (Noir)' }}
      </div>
    </div>
  </div>
</template>

<script>
import { Chess } from 'chess.js'
import boardImage from '@/assets/Images/Chessboard/BOARD.svg'

// Import des images de pièces
import LIGHT_king from '@/assets/Images/Chessboard/ChessPieces/LIGHT_king.svg'
import LIGHT_queen from '@/assets/Images/Chessboard/ChessPieces/LIGHT_queen.svg'
import LIGHT_rook from '@/assets/Images/Chessboard/ChessPieces/LIGHT_rook.svg'
import LIGHT_bishop from '@/assets/Images/Chessboard/ChessPieces/LIGHT_bishop.svg'
import LIGHT_knight from '@/assets/Images/Chessboard/ChessPieces/LIGHT_knight.svg'
import LIGHT_pawn from '@/assets/Images/Chessboard/ChessPieces/LIGHT_pawn.svg'
import DARK_king from '@/assets/Images/Chessboard/ChessPieces/DARK_king.svg'
import DARK_queen from '@/assets/Images/Chessboard/ChessPieces/DARK_queen.svg'
import DARK_rook from '@/assets/Images/Chessboard/ChessPieces/DARK_rook.svg'
import DARK_bishop from '@/assets/Images/Chessboard/ChessPieces/DARK_bishop.svg'
import DARK_knight from '@/assets/Images/Chessboard/ChessPieces/DARK_knight.svg'
import DARK_pawn from '@/assets/Images/Chessboard/ChessPieces/DARK_pawn.svg'

export default {
  name: 'ChessboardM',
  props: {
    size: {
      type: String,
      default: '400px'
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    aiDifficulty: {
      type: Number,
      default: 10,
      validator: value => value >= 1 && value <= 20
    }
  },
  data() {
    return {
      boardImage,
      chess: new Chess(),
      stockfish: null,
      pieces: this.initEmptyBoard(), // Initialisation immédiate
      selectedPiece: null,
      possibleMoves: [],
      possibleCaptures: [],
      currentTurn: 'white',
      status: '',
      isAIThinking: false,
      gameOver: false,
      useSimpleAI: false,
      
      pieceImages: {
        white: {
          k: LIGHT_king,
          q: LIGHT_queen,
          r: LIGHT_rook,
          b: LIGHT_bishop,
          n: LIGHT_knight,
          p: LIGHT_pawn
        },
        black: {
          k: DARK_king,
          q: DARK_queen,
          r: DARK_rook,
          b: DARK_bishop,
          n: DARK_knight,
          p: DARK_pawn
        }
      }
    }
  },
  async mounted() {
    await this.initializeStockfish()
    this.updateBoardFromChess()
  },
  beforeUnmount() {
    if (this.stockfish) {
      this.stockfish.terminate()
    }
  },
  methods: {
    // Initialise un plateau vide 8x8
    initEmptyBoard() {
      return Array(8).fill(null).map(() => Array(8).fill(null))
    },

    async initializeStockfish() {
      try {
        // Utilisation d'une implémentation plus simple pour éviter les problèmes de CDN
        this.useSimpleAI = true
        console.log('Utilisation de l\'IA simple')
      } catch (error) {
        console.error('Erreur lors de l\'initialisation de Stockfish:', error)
        this.useSimpleAI = true
      }
    },
    
    handleStockfishMessage(event) {
      const message = event.data
      
      if (message.startsWith('bestmove')) {
        const moveString = message.split(' ')[1]
        if (moveString && moveString !== '(none)') {
          this.applyAIMove(moveString)
        }
        this.isAIThinking = false
      }
    },
    
    updateBoardFromChess() {
      const board = this.chess.board()
      
      // S'assurer que le tableau pieces est correctement dimensionné
      this.pieces = Array(8).fill(null).map(() => Array(8).fill(null))
      
      // Remplir le plateau avec les pièces de chess.js
      for (let row = 0; row < 8; row++) {
        for (let col = 0; col < 8; col++) {
          const square = board[row][col]
          if (square) {
            this.pieces[row][col] = {
              type: square.type,
              color: square.color === 'w' ? 'white' : 'black'
            }
          }
        }
      }
      
      this.currentTurn = this.chess.turn() === 'w' ? 'white' : 'black'
      this.updateGameStatus()
    },
    
    updateGameStatus() {
      if (this.chess.isCheckmate()) {
        const winner = this.chess.turn() === 'w' ? 'Noir' : 'Blanc'
        this.status = `Échec et mat ! ${winner} gagne !`
        this.gameOver = true
      } else if (this.chess.isDraw()) {
        this.status = 'Match nul !'
        this.gameOver = true
      } else if (this.chess.isCheck()) {
        const player = this.chess.turn() === 'w' ? 'Blanc' : 'Noir'
        this.status = `${player} est en échec !`
      } else {
        this.status = ''
      }
    },
    
    convertToChessNotation(row, col) {
      const files = 'abcdefgh'
      const ranks = '87654321'
      return files[col] + ranks[row]
    },
    
    convertFromChessNotation(notation) {
      const files = 'abcdefgh'
      const ranks = '87654321'
      const col = files.indexOf(notation[0])
      const row = ranks.indexOf(notation[1])
      return { row, col }
    },
    
    getSquareClass(row, col) {
      return (row + col) % 2 === 0 ? 'light' : 'dark'
    },
    
    getPieceImage(piece) {
      if (!piece || !piece.color || !piece.type) return ''
      return this.pieceImages[piece.color][piece.type]
    },
    
    handleSquareClick(row, col) {
      // Vérifications de sécurité
      if (this.readonly || this.gameOver || this.isAIThinking || this.currentTurn === 'black') return
      if (!this.pieces || !this.pieces[row] || row < 0 || row >= 8 || col < 0 || col >= 8) return
      
      const piece = this.pieces[row][col]
      
      // Sélection d'une pièce blanche
      if (piece && piece.color === 'white') {
        if (this.selectedPiece && this.selectedPiece.row === row && this.selectedPiece.col === col) {
          this.clearSelection()
          return
        }
        this.selectedPiece = { row, col }
        this.calculatePossibleMoves(row, col)
        return
      }
      
      // Tentative de mouvement
      if (this.selectedPiece && (this.isPossibleMove(row, col) || this.isCaptureMove(row, col))) {
        this.makePlayerMove(this.selectedPiece.row, this.selectedPiece.col, row, col)
        return
      }
      
      this.clearSelection()
    },
    
    clearSelection() {
      this.selectedPiece = null
      this.possibleMoves = []
      this.possibleCaptures = []
    },
    
    calculatePossibleMoves(row, col) {
      const from = this.convertToChessNotation(row, col)
      const moves = this.chess.moves({ square: from, verbose: true })
      
      this.possibleMoves = []
      this.possibleCaptures = []
      
      moves.forEach(move => {
        const to = this.convertFromChessNotation(move.to)
        if (move.captured) {
          this.possibleCaptures.push(to)
        } else {
          this.possibleMoves.push(to)
        }
      })
    },
    
    isPossibleMove(row, col) {
      return this.possibleMoves.some(move => move.row === row && move.col === col)
    },
    
    isCaptureMove(row, col) {
      return this.possibleCaptures.some(move => move.row === row && move.col === col)
    },
    
    makePlayerMove(fromRow, fromCol, toRow, toCol) {
      const from = this.convertToChessNotation(fromRow, fromCol)
      const to = this.convertToChessNotation(toRow, toCol)
      
      try {
        const move = this.chess.move({ from, to, promotion: 'q' })
        if (move) {
          this.updateBoardFromChess()
          this.clearSelection()
          
          this.$emit('move', {
            from: { row: fromRow, col: fromCol },
            to: { row: toRow, col: toCol },
            move: move,
            fen: this.chess.fen()
          })
          
          // Déclencher le coup de l'IA après un court délai
          if (!this.gameOver && this.currentTurn === 'black') {
            setTimeout(() => {
              this.requestAIMove()
            }, 500)
          }
        }
      } catch (error) {
        console.error('Mouvement invalide:', error)
      }
    },
    
    requestAIMove() {
      if (this.gameOver || this.currentTurn !== 'black') return
      
      this.isAIThinking = true
      
      // Utiliser l'IA simple pour le moment
      setTimeout(() => {
        this.makeSimpleAIMove()
      }, 1000)
    },
    
    makeSimpleAIMove() {
      const moves = this.chess.moves()
      if (moves.length > 0) {
        const randomMove = moves[Math.floor(Math.random() * moves.length)]
        const move = this.chess.move(randomMove)
        if (move) {
          this.updateBoardFromChess()
          
          this.$emit('ai-move', {
            move: move,
            fen: this.chess.fen()
          })
        }
      }
      this.isAIThinking = false
    },
    
    applyAIMove(moveString) {
      try {
        const from = moveString.substring(0, 2)
        const to = moveString.substring(2, 4)
        const promotion = moveString.length > 4 ? moveString[4] : 'q'
        
        const move = this.chess.move({ from, to, promotion })
        if (move) {
          this.updateBoardFromChess()
          
          this.$emit('ai-move', {
            move: move,
            fen: this.chess.fen()
          })
        }
      } catch (error) {
        console.error('Erreur lors de l\'application du coup IA:', error)
        this.makeSimpleAIMove()
      }
    },
    
    // Méthodes publiques
    resetBoard() {
      this.chess.reset()
      this.updateBoardFromChess()
      this.clearSelection()
      this.gameOver = false
      this.isAIThinking = false
    },
    
    getCurrentFEN() {
      return this.chess.fen()
    },
    
    loadPosition(fen) {
      try {
        this.chess.load(fen)
        this.updateBoardFromChess()
        this.clearSelection()
      } catch (error) {
        console.error('Position FEN invalide:', error)
      }
    }
  }
}
</script>

<style scoped>
.chessboard-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.chessboard-container {
  position: relative;
  width: 100%;
  max-width: v-bind(size);
  aspect-ratio: 1/1;
  margin: 0 auto;
  font-family: deonstudio;
}

.board-image {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 1;
}

.coordinates {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  z-index: 200;
  pointer-events: none;
}

.chess-board {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: grid;
  grid-template-rows: repeat(8, 1fr);
  grid-template-columns: repeat(8, 1fr);
  z-index: 3;
}

.row { 
  display: contents; 
}

.square {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.square.disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.square.light { 
  background: transparent; 
}

.square.dark { 
  background: transparent; 
}

.square.selected { 
  background: #c3d6ff !important; 
}

.square.capture { 
  background: rgba(255,0,0,0.3) !important; 
}

.possible-move {
  position: absolute;
  width: 20px; height: 20px;
  border-radius: 50%;
  background: rgba(0,0,0,0.2);
  z-index: 4;
  pointer-events: none;
}

.capture-indicator {
  position: absolute;
  width: 100%; height: 100%;
  border: 3px solid rgba(255,0,0,0.5);
  border-radius: 50%;
  box-sizing: border-box;
  z-index: 4;
  pointer-events: none;
}

.piece {
  width: 90%; height: 90%;
  object-fit: contain;
  user-select: none;
  z-index: 5;
  position: relative;
  transition: transform 0.2s ease;
}

.piece:hover {
  transform: scale(.90);
  
  border: .5em solid #00ff00;
  
  border-radius: 10px;
}

.coordinate-light {
  font-family: deonstudio;
  fill: var(--svg-board-bc);
}

.coordinate-dark {
  font-family: deonstudio;
  fill: var(--svg-board-bg);
}

.game-info {
  margin-top: 20px;
  text-align: center;
  font-family: deonstudio;
}

.ai-thinking {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #ff9500;
  font-size: 1.1em;
  margin-bottom: 10px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #ff9500;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.status {
  font-size: 1.2em;
  margin: 10px 0;
  color: #00ff00;
  font-weight: bold;
}

.turn-indicator {
  font-size: 1em;
  color: #333;
  margin-top: 10px;
}

/* Mode readonly */
.chessboard-wrapper.readonly .square {
  cursor: default;
}
</style>